import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs';
import { ToastService } from './toast.service';
import { UploadService } from './upload.service';

// Keep in sync with ViewContentTypes in ApplicationService.
const PREVIEWABLE_EXTENSIONS = new Set([
  'pdf',
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'txt',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
]);

@Injectable({ providedIn: 'root' })
export class FilePreviewService {
  private uploadService = inject(UploadService);
  private toastService = inject(ToastService);

  canPreview(fileName: string): boolean {
    if (!fileName?.includes('.')) return false;

    const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
    return PREVIEWABLE_EXTENSIONS.has(extension);
  }

  // Open the tab now, during the click. Waiting for the view URL first gets blocked as a popup.
  open(appId: number, fileIdentifier: string): void {
    const tab = window.open('', '_blank');
    if (!tab) {
      this.toastService.error('Allow pop-ups to view this file.', '', 10000);
      return;
    }
    tab.opener = null;

    this.uploadService
      .getAppFileViewUrl(appId, fileIdentifier)
      .pipe(take(1))
      .subscribe({
        next: url => {
          tab.location.href = url;
        },
        error: () => {
          tab.close();
          this.toastService.error('Unable to preview this file. Try downloading it instead.', '', 10000);
        },
      });
  }
}
